export enum NotificationTime {
  Relative = 'Relative',
  Absolute = 'Absolute',
}
